// import React from "react";
// import { Link } from "react-router-dom";
// import moment from "moment";
// import { useTranslation } from "react-i18next";

// const LatestOrdersTable = ({ latestOrders }) => {
//   const { t } = useTranslation();

//   const getOrderStatusText = (status) => {
//     switch (status) {
//       case 0:
//         return "Undelivered";
//       case 1:
//         return "Shipped";
//       case 2:
//         return "Delivered";
//       case 4:
//         return "Return Requested";
//       case 5:
//         return "Request Accepted";
//       case 6:
//         return "Out for Pickup";
//       case 7:
//         return "Pickup Completed";
//       case 8:
//         return "Refund Successful";
//       case 9:
//         return "Cancelled";
//       default:
//         return "NA";
//     }
//   };

//   return (
//     <div className="p-4 dashboard-box flex flex-col border border-gray-200 bg-white shadow-sm md:col-span-2">
//       <div className="flex justify-between items-center">
//         <p className="text-black text-base font-bold self-start">
//           {t("latest_order")}
//         </p>
//         <Link
//           to="/vendor/orders"
//           className="btn bg-primary hover:bg-primary btn-sm rounded"
//         >
//           <span className="!text-white">{t("view_all")}</span>
//         </Link>
//       </div>

//       <div className="w-full py-5">
//         <div className="overflow-x-auto">
//           <table className="table w-full roboto font-bold text-13 text-sm">
//             <thead>
//               <tr>
//                 <th>{t("order_table1")}</th>
//                 <th>{t("order_table2")}</th>
//                 <th>{t("order_table3")}</th>
//                 <th>{t("order_table4")}</th>
//                 <th>{t("order_table5")}</th>
//               </tr>
//             </thead>
//             <tbody>
//               {latestOrders &&
//                 latestOrders.map((lOrder, id) => (
//                   <tr key={id}>
//                     <th>{lOrder?.order_number}</th>
//                     <td>{lOrder?.customer_email}</td>
//                     <td>{lOrder?.order_price} ر.س</td>
//                     <td>
//                       {moment(lOrder?.created_on).format("DD-MMM-YYYY")}
//                     </td>
//                     <td>{getOrderStatusText(lOrder?.order_status)}</td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LatestOrdersTable;


import React from "react";
import { Table, Card, Typography, Button } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const LatestOrdersTable = ({ latestOrders }) => {
  const { t } = useTranslation();

  const getOrderStatusText = (status) => {
    switch (status) {
      case 0:
        return t("Undelivered");
      case 1:
        return t("Shipped");
      case 2:
        return t("Delivered");
      case 4:
        return t("Return Requested");
      case 5:
        return t("Request Accepted");
      case 6:
        return t("Out for Pickup");
      case 7:
        return t("Pickup Completed");
      case 8:
        return t("Refund Successful");
      case 9:
        return t("Cancelled");
      default:
        return "NA";
    }
  };

  const columns = [
    {
      title: t("order_table1"),
      dataIndex: "order_number",
      key: "order_number",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: t("order_table2"),
      dataIndex: "customer_email",
      key: "customer_email",
    },
    {
      title: t("order_table3"),
      dataIndex: "order_price",
      key: "order_price",
      render: (price) => `${price} ر.س`,
    },
    {
      title: t("order_table4"),
      dataIndex: "created_on",
      key: "created_on",
      render: (date) => moment(date).format("DD-MMM-YYYY"),
    },
    {
      title: t("order_table5"),
      dataIndex: "order_status",
      key: "order_status",
      render: (status) => getOrderStatusText(status),
    },
  ];

  return (
    <div className="p-4 dashboard-box flex flex-col border border-gray-200 bg-white shadow-sm md:col-span-2">
    <Card
      title={
        <div className="flex justify-between items-center">
          <Title level={5} className="!mb-0">
            {t("latest_order")}
          </Title>
          <Link to="/vendor/orders">
            <button className="btn btn-primary btn-sm  rounded-md text-white" >
              {t("view_all")}
            </button>
          </Link>
        </div>
      }
    >
      <Table
        dataSource={latestOrders || []}
        columns={columns}
        pagination={false}
        rowKey={(record, index) => index}
        size="middle"
        scroll={{ x: "max-content" }}
      />
    </Card>
    </div>
  );
};

export default LatestOrdersTable;
